import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import { setupForDark } from '@theme';
import React from 'react';

export function parseHighlightedText(
  text?: string,
  normalColor: string = 'text-white',
  highlightedColorClass?: string,
  highlightedColorValue?: string
) {
  if (!text) return <></>;

  // Use highlightedColorValue if provided, otherwise fall back to default accent color.
  // If a class is explicitly provided, use it (processed by setupForDark); otherwise use inline color.
  const highlightedColor = highlightedColorValue || DEFAULT_LANDING_PAGE_ACCENT_COLOR;
  const highlightedClassName = highlightedColorClass
    ? setupForDark(highlightedColorClass)
    : undefined;

  const parts: (string | React.JSX.Element)[] = [];
  let lastIndex = 0;
  const regex = /=(.*?)=/g;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push(
        <span key={key++} className={setupForDark(normalColor)}>
          {text.substring(lastIndex, match.index)}
        </span>
      );
    }

    // Add the highlighted phrase
    parts.push(
      <span
        key={key++}
        className={highlightedClassName}
        style={!highlightedClassName ? { color: highlightedColor } : undefined}
      >
        {match[1]}
      </span>
    );

    lastIndex = regex.lastIndex;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(
      <span key={key++} className={setupForDark(normalColor)}>
        {text.substring(lastIndex)}
      </span>
    );
  }

  return parts.length > 0 ? parts : text;
}
